import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DetalleEstablecimientoService } from '../../funcionario/opciones/establecimiento/establecimiento.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-detalle-solicitud',
	templateUrl: './detalle-solicitud.component.html',
	styleUrls: ['./detalle-solicitud.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetalleSolicitudSoloConsultaComponent implements OnInit {
	suscripcion: Subscription;
	datoSolicitudSharedModel: DatoSolicitudSharedModel;
	descripcion: any;
	// informacion establecimiento
	informacionEstablecimiento: any;
	codigo_camara: string;
	solicitud_id: string;

	constructor(private detalleEstablecimientoService: DetalleEstablecimientoService,
		activedRoute: ActivatedRoute, private router: Router, private dataSharedService: DataSharedService) {
		this.suscripcion = this.dataSharedService.data$.subscribe(dataShared => {
			this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
		});
		this.informacionEstablecimiento = {};
		this.codigo_camara = activedRoute.snapshot.paramMap.get('codigo_camara');
		this.solicitud_id = activedRoute.snapshot.paramMap.get('solicitud_id');
		if (!this.codigo_camara || !this.solicitud_id) {
			router.navigate(['/login']);
		}
	}

	ngOnInit() {
		this.detalleEstablecimientoService
			.getDetalleEstablecimientoPublico({ codigo_camara: this.codigo_camara, solicitud_id: this.solicitud_id }).subscribe(res => {
				if (res.result) {
					this.informacionEstablecimiento = {
						...res.data
					};
					this.dataSharedService.sharedData(this.informacionEstablecimiento);
					this.router.navigate([`/ver-detalle/${this.codigo_camara}/${this.solicitud_id}/establecimientos`]);
				}
			});
	}



}
